import { useAppSelector } from "common/hooks"
import { Role } from "common/types/user.type"

export function useIsInputWritable() {
    const { user: currentUser } = useAppSelector(state => state.auth)
    const currentUserRole = Role[currentUser.role]

    function isInputWritable(minRole) {
        return currentUserRole >= minRole
    }

    return isInputWritable
}
